import './styles/App.css';

import {useEffect, useState} from "react";
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import {Slide, ToastContainer} from 'react-toastify';
import { useAuth } from './hooks/AuthContext.tsx';

import Account from "./pages/account/Account.tsx";
import Episode from "./pages/media/Episode.tsx";
import Header from './components/Header.tsx';
import Home from "./pages/Home.tsx";
import Loader from './components/Loader.tsx'
import Login from "./pages/auth/Login";
import MovieDetails from "./pages/media/MovieDetails.tsx";
import People from "./pages/People.tsx";
import Register from "./pages/auth/Register";
import Search from "./pages/search/Search.tsx";
import Season from "./pages/media/Season.tsx";
import Settings from "./pages/settings/Settings.tsx";
import TvDetails from "./pages/media/TvDetails.tsx";
import TvLayout from "./layouts/TvLayout";

const App = () => {
    const [checkingAuth, setCheckingAuth] = useState(true);
    const { authUser, setAuthUser } = useAuth();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(getAuth(), (currentUser) => {
            setAuthUser(currentUser);
            setCheckingAuth(false);
        });

        return () => unsubscribe();
    }, [setAuthUser]);

    if (checkingAuth) return <Loader fullscreen message="Loading..." />

    return (
        <Router>
            <div>
                <Header showSearch={true} />
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar
                    newestOnTop
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable={false}
                    pauseOnHover
                    theme="light"
                    transition={Slide}
                />
                <div className="background-overlay">
                    <div className="gradient" />
                    <div className="background-image" />
                </div>
                <div className="main">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/account" element={authUser ? <Account /> : <Navigate to="/login?redirect=account" />} />
                        <Route path="/login" element={!authUser ? <Login /> : <Navigate to="/" />} />
                        <Route path="/movie/:id" element={<MovieDetails />} />
                        <Route path="/register" element={!authUser ? <Register /> : <Navigate to="/" />} />
                        <Route path="/search" element={<Search />} />
                        <Route path="/settings" element={authUser ? <Settings /> : <Navigate to="/login?redirect=settings" />} />
                        <Route path="/tv/:id" element={<TvLayout />}>
                            <Route index element={<TvDetails />} />

                            <Route path="season/:season_number" element={<Season />}>
                                <Route path="episode/:episode_number" element={<Episode />} />
                            </Route>
                        </Route>
                        <Route path="/people/:id" element={<People />} />
                        <Route path="*" element={<div>Page Not Found</div>} />
                    </Routes>
                </div>
            </div>
        </Router>
    );
}

export default App;
